import type { B2bcsSubmitLeadFormInput } from '@/types/generated';

export type Commodity = 'ELECTRICITY' | 'GAS';

export interface Address extends Pick<B2bcsSubmitLeadFormInput, 'city' | 'houseNumber' | 'postalCode' | 'street'> {}

export interface CompanyDataInput extends Address, Pick<B2bcsSubmitLeadFormInput, 'companyName'> {
  /** used to identify D&B search results */
  dunsId?: string;
}

export interface ContactDataInput
  extends Pick<B2bcsSubmitLeadFormInput, 'emailAddress' | 'firstname' | 'lastname' | 'telephoneNumber'> {
  emailAddressRepeat: string;
}

export interface DeliverySituationInput extends Partial<Address> {
  consumption: number;
  /** Only for preset total consumption */
  meterCount?: number;
}

export interface ConsumptionInput {
  deliverySituations: Partial<Record<Commodity, DeliverySituationInput[]>>;
}

export const PV_PLANT_TYPES = ['Volleinspeiseanlage', 'Eigenverbrauchsanlage'] as const;

export interface PVInput {
  installationYear: number;
  peakOutput: number;
  plantType: (typeof PV_PLANT_TYPES)[number];
}

export interface SummaryInput extends Pick<B2bcsSubmitLeadFormInput, 'webCampaignId' | 'channelDetail'> {
  marketingOptIn: boolean;
  message?: string;
  privacyPolicyOptIn: boolean;
}

/**
 * Note: Changes here might need to be reflected in the B2C-B2B-handover in
 * `B2BHandoverDTO` in /apps/checkout-b2c/steps/personal-data/business-customer.tsx
 */
export interface LeadFormInput extends CompanyDataInput, ContactDataInput, ConsumptionInput, PVInput, SummaryInput {
  presetConsumption?: {
    commodity: Commodity;
    consumption: number;
    meterCount: number;
  };
}

export type LeadFormState =
  | {
      error?: string;
      input?: Partial<LeadFormInput>;
      loading?: boolean;
      trackingId?: never;
    }
  | {
      error?: never;
      input: Partial<LeadFormInput>;
      loading?: never;
      trackingId: string;
    };
